import { Floater } from "frontend/ui-components/floaters/floater";
import { FitToScreenIcon } from "frontend/icons/fit-to-screen";
import { ZoomIcon } from "frontend/icons/zoom-icon";
import styles from "./zoom-controls.module.css";
import { PortalID } from "frontend/modal/portal-types";
import { createPortal } from "react-dom";
import { isMac } from "utils/keyboard-shortcuts";
import { useIsCIMReorderEnabled } from "utils/url-utils";
import cn from "classnames";

interface ZoomMenuProps {
  menuRef: React.RefObject<HTMLDivElement>;
  zoomButtonRef: React.RefObject<HTMLDivElement>;
  onScaleChange: (newScale: number) => void;
  onZoomToFit: (() => void) | null;
  variant: "cim" | "default";
}

export default function ZoomMenu({ menuRef, zoomButtonRef, onScaleChange, onZoomToFit, variant }: ZoomMenuProps) {
  const portal = document.getElementById(PortalID.Floaters);
  const isCimReorderEnabled = useIsCIMReorderEnabled();

  const element = zoomButtonRef.current ? (
    <Floater
      ref={menuRef}
      relativeTo={zoomButtonRef}
      side="top"
      extraStyle={{
        filter: variant == "cim" ? "none" : "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.20))",
        color: variant == "cim" ? "#1e1e1e" : "#11355e",
        boxShadow: variant == "cim" ? "0 0 10px 0 rgba(0, 0, 0, 0.05)" : "none",
        border: variant == "cim" ? "1px solid #ebedf3" : "none",
        borderRadius: variant == "cim" ? "10px" : "0px",
        marginLeft: isCimReorderEnabled ? "15px" : "0px",
        marginTop: isCimReorderEnabled ? "5px" : "0px",
      }}
    >
      <div className={cn(styles.canvasMenu, isCimReorderEnabled && styles.cimCanvasMenu)}>
        {onZoomToFit && (
          <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={onZoomToFit}>
            <FitToScreenIcon />
            Fit to screen
            {!isCimReorderEnabled && <span className={styles.shortcut}>{isMac() ? "⌥" : "Alt"} 1</span>}
          </span>
        )}
        <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={() => onScaleChange(0.5)}>
          <ZoomIcon />
          50%
        </span>
        <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={() => onScaleChange(0.7)}>
          <ZoomIcon />
          70%
        </span>
        <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={() => onScaleChange(1)}>
          <ZoomIcon />
          100%
        </span>
        <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={() => onScaleChange(1.5)}>
          <ZoomIcon />
          150%
        </span>
        <span className={cn(styles.item, isCimReorderEnabled && styles.cimItem)} onClick={() => onScaleChange(2)}>
          <ZoomIcon />
          200%
        </span>
      </div>
    </Floater>
  ) : null;

  return portal ? createPortal(element, portal) : element;
}
